import logo from './logo.svg';
import './App.css';
import React from 'react';
import { BrowserRouter , Route, Routes, Navigate, Link as RouterLink, useParams } from 'react-router-dom';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Grid from '@cloudscape-design/components/grid';
import Header from '@cloudscape-design/components/header';
import Link from '@cloudscape-design/components/link';
import HelpPanel from '@cloudscape-design/components/help-panel';
import TestForm from './pages/form';
import { CreateRequestForm } from './pages/create-request-form/create-request-form';
import { ExternalAccountForm } from './pages/create-request-form/create-external-account';
import Navigation from './components/navigation';
import Breadcrumbs from './components/breadcrumbs';
import Shell from './layouts/shell';
import ProductionOverview from './layout-pages/home/components/production-overview';
import Flavors from './layout-pages/home/components/flavors';
import QualityReport from './layout-pages/home/components/quality-report';
import { FormFull } from 'pages/form/components/form';
import { AllRequestsTable } from 'pages/table-select-filter-my-applications/AllRequestsTable';
import { UserRequestsTable } from 'pages/table-select-filter-my-applications/UserRequestsTable';
import UserRequestDetails from 'pages/UserRequestDetails'

import { ExternalAccountsTable } from 'pages/table-select-filter-my-applications/ExternalAccounts';
import { ApplicationDetailsTable } from 'pages/table-select-filter/index'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from './AuthContext';

import { variationData, breakdownItems, productionMetrics, quote, notes } from './data';
import { useEffect, useState, useRef } from 'react';
import { signInWithRedirect, signOut, getCurrentUser } from 'aws-amplify/auth';
import { AuthProvider } from './AuthContext';
import { Button } from '@cloudscape-design/components';

export const createAuthenticatedFetch = (auth) => {
  return async (url, options = {}) => {
    if (!auth?.access_token) {
      throw new Error('No access token available');
    }

    const headers = {
      ...options.headers,
      Authorization: `Bearer ${auth.access_token}`,
    };

    return fetch(url, {
      ...options,
      headers,
    });
  };
};


const UserRequestDetailsPage = () => {
  const { id } = useParams();
  
  return (
    <ContentLayout
      header={
        <Header 
          variant="h1" 
        >
          Request Details
        </Header>
      }
    >
      
      <UserRequestDetails id={id} />
    </ContentLayout>
  );
};


const AccountFormPage = () => {
  const { accountId } = useParams();
  
  return (
    <ContentLayout
      header={
        <Header 
          variant="h1" 
        >
          {accountId ? 'Edit Account' : 'Create Account'}
        </Header>
      }
    >
      
      <ExternalAccountForm accountId={accountId} />
    </ContentLayout>
  );
};

const ExternalAccountsTablePage = () => (
  <ContentLayout
    header={
      <Header variant="h1" >
        {/* External Account Table */}
      </Header>
    }
  >
    <ExternalAccountsTable />
  </ContentLayout>
);


const CreateRequestFormPage = () => (
  <ContentLayout
    header={
      <Header variant="h1" >
        Create Request Form
      </Header>
    }
  >
    <CreateRequestForm />
  </ContentLayout>
);



const IndicatorSubmissionPage = () => {
  const { indicatorSubmissionID } = useParams();
  return (
  <ContentLayout
    header={
      <Header variant="h1" >
        {/* Indicator Submission */}
      </Header>
    }
  >
    <FormFull indicatorSubmissionID={indicatorSubmissionID} />
  </ContentLayout>
);
}


const UserRequestsTablePage = () => (
  <ContentLayout
    header={
      <Header variant="h1">
        {/* All Requests */}
      </Header>
    }
  >
    <UserRequestsTable />
  </ContentLayout>
);


const MyApplicationsPage = () => (
  <ContentLayout
    header={
      <Header variant="h1">
        {/* All Requests */}
      </Header>
    }
  >
    <AllRequestsTable />
  </ContentLayout>
);


// const config = {
//     Auth: {
//         userPoolId: 'us-east-1_QLIR5NFnx',
//         userPoolClientId: '5btemk829r1basaumt5hqsk5a6',
//         region: 'us-east-1',
//         signInWithRedirect: {
//             domain: 'us-east-1qlir5nfnx.auth.us-east-1.amazoncognito.com',
//             redirectSignIn: ['http://localhost:8000/api/v1/auth/callback'],
//             redirectSignOut: ['https://pam-dev.cruugo.me/'],
//             responseType: 'code',
//             scopes: ['email', 'openid', 'profile']
//         }
//     }
// };

export const ProtectedRoute = ({ children, requiredRole }) => {
  const { auth } = useAuth();

  if (!auth) {
    return <Navigate to="/authentiate" replace />;
  }
  
  if (requiredRole && auth.role !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

const SimpleAuthTestTest = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const exchangeHandled = useRef(false);

  useEffect(() => {
    const code = searchParams.get('code');
    if (code && !exchangeHandled.current) {
      exchangeHandled.current = true;
      handleCodeExchange(code);
    }
  }, [searchParams]);
  
  const handleCodeExchange = async (code) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/auth/oauth2_callback_code_exchange?code=${code}`, {
        method: 'GET',
      });
      
      if (!response.ok) {
        throw new Error('Failed to exchange code');
      }

      const tokens = await response.json();
      login(tokens);
      navigate('/my-applications'); // Redirect to home page after successful login
    } catch (error) {
      console.error('Error exchanging code:', error);
      navigate('/authentiate'); // Redirect to login page on error
    }
  };

  return <div className="p-8">Processing authentication...</div>;
};




const SimpleAuthTest = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);

  // Check if we're on the callback URL
  useEffect(() => {
      if (window.location.pathname === '/api/v1/auth/callback') {
          checkUser();
      }
  }, []);

  // Check current auth state
  const checkUser = async () => {
      try {
          const currentUser = await getCurrentUser();
          setUser(currentUser);
          setError(null);
      } catch (err) {
          setUser(null);
          setError('Not authenticated');
      }
  };

  const handleSignIn = async () => {
      try {
          await signInWithRedirect();
      } catch (err) {
          setError(err.message);
          console.error('Sign in error:', err);
      }
  };

  const handleSignOut = async () => {
      try {
          await signOut();
          setUser(null);
      } catch (err) {
          setError(err.message);
          console.error('Sign out error:', err);
      }
  };

  return (
      <div className="p-8">
          <h1 className="text-2xl mb-4">Signin</h1>
          
          {error && (
              <div className="mb-4 p-4 bg-red-100 text-red-700 rounded">
                  Error: {error}
              </div>
          )}

          {user ? (
              <div>
                  <div className="mb-4 p-4 bg-green-100 rounded">
                      ✓ Authenticated
                      <pre className="mt-2 text-sm">
                          {JSON.stringify(user, null, 2)}
                      </pre>
                  </div>
                  <button
                      onClick={handleSignOut}
                      className="bg-red-500 text-white px-4 py-2 rounded"
                  >
                      Sign Out
                  </button>
              </div>
          ) : (
              <button
                  //onClick={handleSignIn}
                  className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                  {/* <a href="https://us-east-1qlir5nfnx.auth.us-east-1.amazoncognito.com/oauth2/authorize?client_id=5btemk829r1basaumt5hqsk5a6&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=http://localhost:3000/api/v1/auth/callback&idp_identifier=pam"> Signin to PAM</a> */}
                  <a href={`${process.env.REACT_APP_MAIN_COGNITO_URL}/oauth2/authorize?client_id=${process.env.REACT_APP_MAIN_COGNITO_CLIENT_ID}&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=${process.env.REACT_APP_COGNITO_OAUTH2_CALLBACK}&idp_identifier=pam`}> Signin to PAM</a>

              </button>
          )}

      </div>
  );
};


// const AuthenticatePage = () => {
//   return (
//   <ContentLayout
//     header={
//       <Header variant="h1" >
//         {/* Application Details Page */}
//       </Header>
//     }
//   >
//     <p>Hi, this is the AuthenticatePage</p>
//   </ContentLayout>
//   )
// };


const ApplicationDetailsPage = () => {
  const{ applicationID }  = useParams();
  return (
  <ContentLayout
    header={
      <Header variant="h1" >
        {/* Application Details Page */}
      </Header>
    }
  >
    <ApplicationDetailsTable loadHelpPanelContent={null} applicationID={applicationID}/>
  </ContentLayout>
  )
};




// Dashboard component with all three sections
const Dashboard = () => (
  <ContentLayout
    header={
      <Header variant="h1">
        {/* Dashboard */}
      </Header>
    }
  >
    <Grid gridDefinition={[{ colspan: 12 }, { colspan: 8 }, { colspan: 4 }]} disableGutters={false}>
      <ProductionOverview metrics={productionMetrics} />
      <Flavors data={variationData} items={breakdownItems} />
      <QualityReport quote={quote} notes={notes} />
    </Grid>
  </ContentLayout>
);

// Navigation links component
const NavLinks = () => (
  <div className="nav-links">
    {/* <RouterLink to="/dashboard" className="nav-link">Dashboard</RouterLink>
    <RouterLink to="/production" className="nav-link">Production Overview</RouterLink>
    <RouterLink to="/flavors" className="nav-link">Flavors Analysis</RouterLink>
    <RouterLink to="/quality" className="nav-link">Quality Report</RouterLink> */}
    <RouterLink to="/indicator-submission" className="nav-link">Indicator Submission</RouterLink>
    <RouterLink to="/my-applications" className="nav-link">My Requests</RouterLink>
    <RouterLink to="/all-applications" className="nav-link">All Requests</RouterLink>
    <RouterLink to="/external-accounts" className="nav-link">External Accounts</RouterLink>

    <RouterLink to="/application-details" className="nav-link">Application Details</RouterLink>

    <RouterLink to="/create-request" className="nav-link">Create Request</RouterLink>
    <RouterLink to="/external-accounts/new" className="nav-link">Create Account</RouterLink>
    <RouterLink to="/signout" className="nav-link">Sign-Out</RouterLink>
    
  </div>
);


// function App() {
//   return (
//     <BrowserRouter>

//     <div className="App">
//     <Shell
//                 defaultPadding
//                 disableOverlap
//                 headerVariant="high-contrast"
    
//       // breadcrumbs={<Breadcrumbs active={{ text: 'Dashboard2', href: '/home/index.html' }} />}
//       navigation={<Navigation />}
//       // tools={<HelpPanel header={<h2>Help panel</h2>} />}
//     >
//           <Routes>
//             <Route path="/indicator-submission/:indicatorSubmissionID" element={<IndicatorSubmissionPage />} />
//             <Route path="/my-applications" element={<UserRequestsTablePage />} />
//             <Route path="/all-applications" element={<MyApplicationsPage />} />
//             <Route path="/external-accounts" element={<ExternalAccountsTablePage />} />
//             <Route path="/application-details/:applicationID" element={<ApplicationDetailsPage />} />
//             <Route path="/create-request" element={<CreateRequestFormPage />} />
            
//             <Route path="/external-accounts/new" element={<AccountFormPage />} />
//             <Route path="/external-accounts/edit/:accountId" element={<AccountFormPage />} />
            
            
//             <Route path="/" element={<Navigate to="/my-applications" replace />} />
//             <Route path="/authentiate" element={<SimpleAuthTest />} />
//             <Route path="/api/v1/auth/callback" element={<SimpleAuthTestTest />} />

//           </Routes>

//       {/* <ContentLayout
//             header={
//           <Header variant="h1" info={<Link variant="info">Info</Link>}>
//             Dashboard
//           </Header>
//         }
//       >
//         <Grid gridDefinition={[{ colspan: 12 }, { colspan: 8 }, { colspan: 4 }]} disableGutters={false}>
//           <ProductionOverview metrics={productionMetrics} />
//           <Flavors data={variationData} items={breakdownItems} />
//           <QualityReport quote={quote} notes={notes} />
//         </Grid>
//       </ContentLayout> */}
//     </Shell>

//     </div>
//     </BrowserRouter>

//   );
// }
const SignOutComponent = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    navigate('/', { replace: true });
  }, []);

  return null;
};


function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Shell
            defaultPadding
            disableOverlap
            headerVariant="high-contrast"
            navigation={<Navigation />}
          >
            <Routes>
              {/* Public routes */}
              <Route path="/authentiate" element={<SimpleAuthTest />} />
              <Route path="/api/v1/auth/callback" element={<SimpleAuthTestTest />} />

              {/* Protected routes - Employee & Admin */}
              <Route
                path="/my-applications"
                element={
                  <ProtectedRoute >
                    <UserRequestsTablePage />
                  </ProtectedRoute>
                }
              />

              {/* Admin-only routes */}
              <Route
                path="/all-applications"
                element={
                  <ProtectedRoute >
                    <MyApplicationsPage requiredRole="admin" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/external-accounts"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <ExternalAccountsTablePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/create-request"
                element={
                  <ProtectedRoute >
                    <CreateRequestFormPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/my-requests/:id"
                element={
                  <ProtectedRoute>
                    <UserRequestDetailsPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/external-accounts/new"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AccountFormPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/external-accounts/edit/:accountId"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AccountFormPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/requests/:id"
                element={
                  <ProtectedRoute requiredRole="admin">
                  <UserRequestDetailsPage/>
                  </ProtectedRoute>
                  }
              />
              <Route path="/" element={<Navigate to="/my-applications" replace />} />
              <Route 
                  path="/signout" 
                  element={
                    <SignOutComponent />
                  }
                />            
                </Routes>
          </Shell>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
export default App;
